import React, { useEffect, useMemo } from 'react';
import classnames from 'classnames';

import { useYotpoScript } from '../yotpo-script';

import { YotpoWidgetProps } from './types';
import getYotpoWidgetAttributes from './widget-attributes';

export function YotpoWidget(props: YotpoWidgetProps) {
    const { instanceId } = props;
    const productId = props.product?.id;

    const { reloadWidgets } = useYotpoScript();

    const hasRequiredProps = useMemo(() => instanceId && productId, [instanceId, productId]);

    const yotpoAttributes = useMemo(() => getYotpoWidgetAttributes(props), [props]);

    useEffect(() => {
        if (hasRequiredProps) {
            reloadWidgets();
        }
    }, [hasRequiredProps, reloadWidgets]);

    if (!hasRequiredProps) {
        return null;
    }

    return <div className={classnames(['yotpo-widget-instance', props.className])} {...yotpoAttributes}></div>;
}

export type YotpoWidget = typeof YotpoWidget;

export default YotpoWidget;
